module.exports = __webpack_public_path__ + "img/t2s.ae0847d6.svg";